import _ from 'lodash';
import React, { useState } from 'react';
import { DataTestId } from '@jvs-group/jvs-mairistem-tools';
import { Button, Menu, Popup } from "../..";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A menu displays grouped navigation actions.
 */
var CollectionListItemMenu = function CollectionListItemMenu(props) {
  var _useState = useState(!!props.open),
    open = _useState[0],
    setOpen = _useState[1];

  /** Handle Open event. */
  var handleOpen = function handleOpen() {
    return setOpen(true);
  };

  /** Handle Close event. */
  var handleClose = function handleClose() {
    return setOpen(false);
  };

  /** Handle item overrides props. */
  var handleItemOverrides = function handleItemOverrides(predefinedProps) {
    return {
      onClick: function onClick(event, itemProps) {
        setOpen(false);
        _.invoke(predefinedProps, 'onClick', event, itemProps);
        _.invoke(props, 'onItemClick', event, itemProps);
        event.stopPropagation();
      }
    };
  };

  /** Handle click trigger (to stop propagation if onItemSelect is given to CollectionList) */
  var handleClickTrigger = function handleClickTrigger(event) {
    return event.stopPropagation();
  };

  /** Render items. */
  var renderItems = function renderItems() {
    var items = props.items,
      menuFirst = props.menuFirst;
    return _.orderBy(
    // @ts-expect-error Semantic issue
    _.map(items, function (item) {
      return Menu.Item.create(item, {
        overrideProps: handleItemOverrides
      });
    }), ['props.content', 'key'], [!_.isNil(menuFirst) && menuFirst ? 'desc' : 'asc', 'asc']);
  };

  /** Render the component. */
  var render = function render() {
    var _children = props.children,
      className = props.className;
    var rest = getRest(CollectionListItemMenu, props);
    return /*#__PURE__*/_jsx(DataTestId.Accessor, {
      dataTestId: "collection-item-menu",
      children: function children(dataTestId) {
        return /*#__PURE__*/_jsx(Popup, {
          className: className,
          trigger: /*#__PURE__*/_jsx(Button, {
            "data-testid": dataTestId,
            icon: "bars",
            onClick: handleClickTrigger
          }),
          content: /*#__PURE__*/_jsx(Menu, Object.assign({}, rest, {
            fluid: true,
            vertical: true,
            secondary: true,
            children: _.isNil(_children) || _.isEmpty(_children) ? renderItems() : _children
          })),
          on: "click",
          open: open,
          onClose: handleClose,
          onOpen: handleOpen,
          position: "bottom right",
          popperModifiers: [{
            name: 'preventOverflow',
            options: {
              boundariesElement: 'offsetParent'
            }
          }]
        });
      }
    });
  };
  render.handledProps = [];
  return render();
};
CollectionListItemMenu.handledProps = [];
export default CollectionListItemMenu;